import {withSubjectPageCopy} from 'client/Seo/subjectPageCopy';

interface SubjectForMetadata {
  getName(): string;
  getDescription(): string;
  getUrlSlug(): string;
}

/** Head metadata for a subject page's practice and assessments tabs, for `withApplicationMetadata`. */
export function studyGuideMetadata(subject: SubjectForMetadata, pathname: string) {
  const isAssessment = /\/assessments\/?$/i.test(pathname);
  const slug = subject.getUrlSlug();

  return withSubjectPageCopy(subject.getName(), {
    title: `${subject.getName()} | ${isAssessment ? 'Assessment' : 'Practice'} | Albert`,
    metaDescription: subject.getDescription(),
    canonicalPath: isAssessment ? `/${slug}/assessments` : `/${slug}`
  });
}
